import dynamic from "next/dynamic";
const AsymmetricSideBySideTextAndAssetComponent = dynamic(()=>import("./asymmetric-side-by-side-text-and-asset-component"));
import AsymmetricSideBySideTextAndAssetConfig from "./asymmetric-side-by-side-text-and-asset-config";
import AsymmetricSideBySideTextAndAssetAdvancedConfig from "./asymmetric-side-by-side-text-and-asset-advanced-config";
export default {
    AsymmetricSideBySideTextAndAssetComponent,
    AsymmetricSideBySideTextAndAssetConfig,
    AsymmetricSideBySideTextAndAssetAdvancedConfig
};
